// extracted by mini-css-extract-plugin
module.exports = {"overlay":"SendMessageOverlay_overlay__34CRR","container":"SendMessageOverlay_container__3aKIG","or":"SendMessageOverlay_or__1XpXG","trigger":"SendMessageOverlay_trigger__tNSUB"};